import { Modal, type IModalProps } from '@/react/components/core-ui/Modal';
import { ModalHeader } from '@/react/components/core-ui/Modal/ModalHeader';
import type { FunctionComponent } from 'react';

import { useLocaleMessage } from '@/react/hooks/useLocaleMessage';
import S from './styles.base.module.scss';
import { product_details_contentBlocks_freeShipping_modal_title } from "@/lang/__generated__/ahnu/product_details_contentBlocks_freeShipping_modal_title";
import { product_details_contentBlocks_freeShipping_modal_paragraphTitle1 } from "@/lang/__generated__/ahnu/product_details_contentBlocks_freeShipping_modal_paragraphTitle1";
import { product_details_contentBlocks_freeShipping_modal_paragraph1 } from "@/lang/__generated__/ahnu/product_details_contentBlocks_freeShipping_modal_paragraph1";
import { product_details_contentBlocks_freeShipping_modal_paragraphTitle2 } from "@/lang/__generated__/ahnu/product_details_contentBlocks_freeShipping_modal_paragraphTitle2";
import { product_details_contentBlocks_freeShipping_modal_paragraph2 } from "@/lang/__generated__/ahnu/product_details_contentBlocks_freeShipping_modal_paragraph2";
import { product_details_contentBlocks_freeShipping_modal_closeButton } from "@/lang/__generated__/ahnu/product_details_contentBlocks_freeShipping_modal_closeButton";

/**
 * The props for the FreeShippingInformationModal component.
 * Extends the IModalProps interface without the children property, since it's not necessary.
 */
type FreeShippingInformationModalProps = Omit<IModalProps, 'children'>;

/**
 * A modal that displays more information about free shipping and free returns.
 */
export const FreeShippingInformationModal: FunctionComponent<
  FreeShippingInformationModalProps
> = (props) => {
  const { onClose } = props;

  const [msg] = useLocaleMessage();

  return (
    <Modal {...props}>
      <ModalHeader
        className={S.modalHeader}
        iconClass={S.closeIcon}
        onClose={onClose}
      >
        <h2 className={S.modalTitle}>
          {msg(product_details_contentBlocks_freeShipping_modal_title)}
        </h2>
      </ModalHeader>
      <div className={S.modalBody}>
        <h2 className={S.title}>
          {msg(
            product_details_contentBlocks_freeShipping_modal_paragraphTitle1
          )}
        </h2>
        <p className={S.description}>
          {msg(product_details_contentBlocks_freeShipping_modal_paragraph1)}
        </p>
        <h2 className={S.title}>
          {msg(
            product_details_contentBlocks_freeShipping_modal_paragraphTitle2
          )}
        </h2>
        <p className={S.description}>
          {msg(product_details_contentBlocks_freeShipping_modal_paragraph2)}
        </p>
        <button type="button" className={S.closeButton} onClick={onClose}>
          {msg(product_details_contentBlocks_freeShipping_modal_closeButton)}
        </button>
      </div>
    </Modal>
  );
};
